module.exports = __webpack_public_path__ + "img/Agent_info_docu_06_IK.344db9f3.jpg";